import { Image as ImageShp } from "@shopify/hydrogen"
import { useEffect, useState } from "react"

export default function ImageDevice({src, alt, className, height, width}) {
  const [browserWidth, setBrowserWidth] = useState(0);
  
  useEffect(()=>{
    const width = window.innerWidth;
    setBrowserWidth(width);
  },[])

  return (
  <>
    <ImageShp
      src={
        (browserWidth < 576)
        ? src+'?fm=webp&h=420&w=240'
        : src
      }
      height={height}
      width={width}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
    />
  </>)
}